import React from 'react'

const licInfoExpandContent = function(isEwal) {
  return (
    <>
      <div>
        {isEwal
          ? `Pracujesz w wersji demonstracyjnej programu. Aby odblokować możliwość pobrania pliku XML z e-Sprawozdaniem, kup licencję.`
          : `Upłynął termin ważności Twojej licencji. Aby odblokować możliwość pobrania pliku XML z e-Sprawozdaniem, odnów licencję.`}
      </div>
      <br />
      <div>
        {isEwal
          ? `W wersji demonstracyjnej masz dostęp do wszystkich przygotowanych przez nas struktur e-Sprawozdań. Możesz też swobodnie korzystać z wszystkich funkcji programu, za wyjątkiem możliwości pobrania pliku XML zawierającego końcowy efekt Twojej pracy nad e-Sprawozdaniem.`
          : `Po upływie terminu ważności licencji możesz nadal uruchamiać program, wczytywać i przeglądać pliki z e-Sprawozdaniami oraz testowo korzystać z wszystkich funkcji edycyjnych programu. Nie będziesz jednak w stanie pobrać pliku XML zawierającego Twoje zmiany w e-Sprawozdaniu.`}
      </div>
    </>
  )
}

const licInfoRolledContent = function(isEwal) {
  return (
    <div>
      {isEwal
        ? `Pracujesz w wersji demonstracyjnej programu. Aby odblokować możliwość pobrania pliku XML z e-Sprawozdaniem, kup licencję.`
        : `Upłynął termin ważności Twojej licencji. Aby odblokować możliwość pobrania pliku XML z e-Sprawozdaniem, odnów licencję.`}
    </div>
  )
}

export { licInfoExpandContent, licInfoRolledContent }
